module.exports = __webpack_public_path__ + "static/img/HXCX.a77b611.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HXCX.png
// module id = b++V
// module chunks = 34